import Wrapper from "../assets/wrappers/SmallSidebar";
import { FaTimes } from "react-icons/fa";
import { useAppContext } from "../context/appContext";
import NavLinks from "./NavLinks";
import { LargeLogo } from ".";

function SmallSidebar() {
  const { showSidebar, toggleSidebar, user, version } = useAppContext();

  // add show-sidebar class to display the sidebar
  let mainClassName = showSidebar
    ? "show-sidebar sidebar-container mobile-nav"
    : "sidebar-container mobile-nav";
  // add sandbox class if selected
  mainClassName = user?.user_mode ? mainClassName + " sandbox" : mainClassName;

  return (
    <Wrapper>
      <div className={mainClassName}>
        <button className="close-btn" type="button" onClick={toggleSidebar}>
          <FaTimes />
        </button>
        <div className="logo-area whole">
          <LargeLogo />
        </div>
        <div className="whole">
          <NavLinks toggleSidebar={toggleSidebar} user={user} />
        </div>
        <div className="program">{`FreeLite JMS 3 v. ${version}`}</div>
      </div>
    </Wrapper>
  );
}
export default SmallSidebar;
